import i18next from 'i18next';

i18next.addResources('es_CL', 'DeliverySwitch', {
  ownDelivery: 'Delivery propio',
  peyaDelivery: 'Delivery PedidosYa',
  uberDelivery: 'Delivery Uber',
  cabifyDelivery: 'Delivery Cabify',
  uberDaasDelivery: 'Delivery Uber DaaS',
  peyaV3Delivery: 'Delivery PedidosYa V3',
  rappiCargoDelivery: 'Delivery Rappi cargo'
});

i18next.addResources('es_CR', 'DeliverySwitch', {
  ownDelivery: 'Delivery propio',
  peyaDelivery: 'Delivery PedidosYa',
  uberDelivery: 'Delivery Uber',
  cabifyDelivery: 'Delivery Cabify',
  uberDaasDelivery: 'Delivery Uber DaaS',
  peyaV3Delivery: 'Delivery PedidosYa V3',
  rappiCargoDelivery: 'Delivery Rappi cargo'
});
